import InventoryDetailsFormContainer from './components/Inventory/InventoryDetails/InventoryDetailsFormContainer';
import InventoryOverview from './components/Inventory/InventoryOverview/InventoryOverview';
import ChemicalProductOverview from './components/ChemicalProduct/ChemicalProductOverview/ChemicalProductOverview';
import ChemicalProductDetailsFormContainer from './components/ChemicalProduct/ChemicalProductDetails/ChemicalProductDetailsFormContainer';
import InventoryHistoryDetailsFormContainer from './components/Inventory/InventoryDetails/InventoryHistoryDetailsFormContainer';
import {
  CLONE_MODE,
  CREATE_MODE,
  DELETED_OVERVIEW_TYPE,
  EDIT_MODE,
  ENTITY_OVERVIEW_TYPE,
  HISTORY_OVERVIEW_TYPE,
  REPORT_MODE,
  UNDO_DELETE_MODE,
  VIEW_MODE,
  MOBILE,
} from './constants';
import ChemicalProductHistoryDetailsFormContainer from './components/ChemicalProduct/ChemicalProductDetails/ChemicalProductHistoryDetailsFormContainer';
import ForbiddenPage from './pages/ForbiddenPage';
import JobManagementPage from './components/JobManagementPage';
import BuildingSummaryFormContainer from './components/BuildingSummary/BuildingSummaryFormContainer';
import BatchUpdateContainer from './components/BatchUpdate/BatchUpdateContainer';
import HomeComponent from './components/Home/HomeComponent';
import ErrorPage from './pages/ErrorPage';
import AccessRequestPage from './pages/AccessRequestPage';
import RequiredLmsCoursesPage from './pages/RequiredLmsCoursesPage';
import InventoryOverviewMobileComponent from './components/Filtering/OverviewTable/InventorySimplifiedView/InventoryOverviewMobileComponent';
import ActivityDetailsFormContainer from '@components/Activity/ActivityFormContainer';
import { QueryKey } from '@behavior/QueryKey';
import ViewEditAcivity from '@components/Activity/overview/ViewEditAcivity';
import ActivityOverviewContainer from '@components/Activity/overview/ActivityOverviewContainer';
import ActionsDetailsContainer from '@components/Activity/ActionsDetailsContainer';
import ActionContainer from '@components/Activity/ActionContainer';
import ChemicalProductSdsFileDownloadContainer from '@components/ChemicalProduct/ChemicalProductSdsFileDownload/ChemicalProductSdsFileDownloadContainer';

export const Inventory = {
  baseName: '/inventories',
  shortName: '/i',
  children: {
    inventoryCreate: {
      route: (mode?: string) => Inventory.baseName + (mode ? `/${mode}` : `/:mode(${CREATE_MODE})`),
      component: InventoryDetailsFormContainer,
    },
    inventoryDetails: {
      route: (id?: string, mode?: string) =>
        Inventory.baseName +
        (mode
          ? `/${mode}`
          : `/:mode(${VIEW_MODE}|${EDIT_MODE}|${CLONE_MODE}|${UNDO_DELETE_MODE})`) +
        (id ? `/${id}` : `/:id`),
      component: InventoryDetailsFormContainer,
    },
    // Redirect for short url in QR codes
    inventoryDetailsShort: {
      route: (id: string, mode: string) =>
        Inventory.baseName + (mode ? `/${mode}` : `/:mode(${MOBILE})`) + (id ? `/${id}` : `/:id`),
      component: InventoryOverviewMobileComponent,
    },
    //Redirect for mobile view
    inventoryDetailsMobile: {
      route: (id?: string, mode?: string) =>
        Inventory.baseName + (mode ? `/${mode}` : `/:mode(${MOBILE})`) + (id ? `/${id}` : `/:id`),
      component: InventoryOverviewMobileComponent,
    },
    inventoryHistoryDetails: {
      route: (id?: string) =>
        Inventory.baseName + `/${VIEW_MODE}` + '/history' + (id ? `/${id}` : `/:id`),
      component: InventoryHistoryDetailsFormContainer,
    },
    inventoryOverview: {
      route: (overviewType?: string) =>
        Inventory.baseName +
        `/overview` +
        (overviewType
          ? `/${overviewType}`
          : `/:overviewType(${ENTITY_OVERVIEW_TYPE}|${DELETED_OVERVIEW_TYPE})`),
      component: InventoryOverview,
    },
    inventoryHistoryOverview: {
      route: (id?: string, overviewType?: string) =>
        Inventory.baseName +
        `/overview` +
        (overviewType ? `/${overviewType}` : `/:overviewType(${HISTORY_OVERVIEW_TYPE})`) +
        (id ? `/${id}` : `/:id`),
      component: InventoryOverview,
    },
  },
};

export const Activity = {
  baseName: `/${QueryKey.ACTIVITY}`,
  children: {
    activityCreate: {
      route: (mode?: string) => Activity.baseName + (mode ? `/${mode}` : `/:mode(${CREATE_MODE})`),
      component: ActivityDetailsFormContainer,
    },
    activityDetails: {
      route: (id?: string, mode?: string) =>
        Activity.baseName +
        (mode ? `/${mode}` : `/:mode(${VIEW_MODE}|${EDIT_MODE}|${CLONE_MODE})`) +
        (id ? `/${id}` : `/:id`),
      component: ViewEditAcivity,
    },
    activityOverview: {
      route: () => Activity.baseName + `/activityOverview`,
      component: ActivityOverviewContainer,
    },
  },
};

export const ChemicalProduct = {
  baseName: '/chemicalProducts',
  children: {
    chemicalProductCreate: {
      route: (mode?: string) =>
        ChemicalProduct.baseName + (mode ? `/${mode}` : `/:mode(${CREATE_MODE})`),
      component: ChemicalProductDetailsFormContainer,
    },
    chemicalProductDetails: {
      route: (id?: string, mode?: string) =>
        ChemicalProduct.baseName +
        (mode ? `/${mode}` : `/:mode(${VIEW_MODE}|${EDIT_MODE}|${REPORT_MODE}|${CLONE_MODE})`) +
        (id ? `/${id}` : `/:id`),
      component: ChemicalProductDetailsFormContainer,
    },
    chemicalProductHistoryDetails: {
      route: (id?: string) =>
        ChemicalProduct.baseName + `/${VIEW_MODE}` + '/history' + (id ? `/${id}` : `/:id`),
      component: ChemicalProductHistoryDetailsFormContainer,
    },
    chemicalProductSdsFileDownlaod: {
      route: (id?: string) => '/files/sdsFileDownload' + (id ? `/${id}` : `/:id`),
      component: ChemicalProductSdsFileDownloadContainer,
      matchRouteRegex: /\/files\/sdsFileDownload(\/\d+)?$/,
    },
    chemicalProductOverview: {
      route: (overviewType?: string) =>
        ChemicalProduct.baseName +
        `/overview` +
        (overviewType ? `/${overviewType}` : `/:overviewType(${ENTITY_OVERVIEW_TYPE})`),
      component: ChemicalProductOverview,
    },
    chemicalProductHistoryOverview: {
      route: (id?: string, overviewType?: string) =>
        ChemicalProduct.baseName +
        `/overview` +
        (overviewType ? `/${overviewType}` : `/:overviewType(${HISTORY_OVERVIEW_TYPE})`) +
        (id ? `/${id}` : `/:id`),
      component: ChemicalProductOverview,
    },
  },
};

export const Action = {
  baseName: '/actions',
  children: {
    allActions: {
      route: () => Action.baseName + '/all',
      component: ActionsDetailsContainer,
    },
    actionDetails: {
      route: (id?: string) => Action.baseName + (id ? `/${id}` : `/:id`),
      component: ActionContainer,
    },
  },
};

export const Forbidden = {
  route: () => '/forbidden',
  component: ForbiddenPage,
};

export const JobManagement = {
  route: () => '/jobs',
  component: JobManagementPage,
};

export const AccessRequest = {
  route: () => '/accessRequest',
  component: AccessRequestPage,
};

export const RequiredLmsCourses = {
  route: () => '/requiredLmsCourses',
  component: RequiredLmsCoursesPage,
};

export const BatchUpdate = {
  route: () => '/batchUpdate',
  component: BatchUpdateContainer,
};

export const Error = {
  baseName: '/error',
  children: {
    generic: {
      route: () => Error.baseName,
      component: ErrorPage,
    },
    withCode: {
      route: (errorCode?: number) => '/error' + (errorCode ? `/${errorCode}` : `/:errorCode`),
      component: ErrorPage,
    },
  },
};

export const Home = {
  route: () => '/',
  component: HomeComponent,
};

export const Buildings = {
  baseName: '/buildings',
  children: {
    search: {
      route: () => Buildings.baseName + `/search`,
      component: BuildingSummaryFormContainer,
    },
    summaryById: {
      route: (id?: string) => Buildings.baseName + (id ? `/${id}` : `/:id(\\d+)`), // RRA-945. support by id due to old urls and edms documents
      component: BuildingSummaryFormContainer,
    },
    summaryByNum: {
      route: (buildingNum?: string) =>
        Buildings.baseName + '/num' + (buildingNum ? `/${buildingNum}` : `/:buildingNum(\\d+)`),
      component: BuildingSummaryFormContainer,
    },
  },
};

export default {
  Inventory,
};
